import { CustomLogicRequirementCoreBase } from "./custom-logic-requirement.core.base"


export class CustomLogicRequirementCore extends CustomLogicRequirementCoreBase {

}